import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { createSelector } from 'reselect';
import ModalAlterarSenha from "../../Components/Common/ModalAtualizarSenha";
import { fetchComAuth, fetchComAuthJson } from '../../common/api';

const ProfileDropdown = () => {

    const [modalAtualizarSenha, setModalAtualizarSenha] = useState(false);
    const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);
    const [loading, setLoading] = useState(false);
  
    const profiledropdownData = createSelector(
        (state) => state.Profile,
        (user) => user?.user
      );
    
    const abrirModalAtualizarSenha = (user) => {
        setUsuarioSelecionado(user);
        setModalAtualizarSenha(true);
    };


    const fecharModalAtualizarSenha = () => {
        setModalAtualizarSenha(false);
        setUsuarioSelecionado(null);
    };

    const [user, setUser] = useState(null);

    useEffect(() => {
        const auth = sessionStorage.getItem("authUser");
        if (auth) {
            const obj = JSON.parse(auth);
            setUser(obj?.user);
            setUserName(obj?.user?.name ?? 'EVOMAP');
            setTipo(obj?.user?.tipo ?? 'EVOMAP');
        }
    }, []);

    
    const [userName, setUserName] = useState("Admin");
    const [tipo, setTipo] = useState("EVOMAP");

    useEffect(() => {
        if (sessionStorage.getItem("authUser")) {
            const obj = JSON.parse(sessionStorage.getItem("authUser"));
            setUserName(obj?.user.name ?? 'EVOMAP');
            setTipo(obj?.user.tipo ?? 'EVOMAP');
        }
    }, [userName, user, tipo]);

    //Dropdown Toggle
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };
    return (
        <React.Fragment>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user">
                <DropdownToggle tag="button" type="button" className="btn shadow-none">
                    <span className="d-flex align-items-center">
                        <span className="text-start ms-xl-2">
                            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{userName}</span>
                            <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">{tipo}</span>
                        </span>
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <DropdownItem onClick={() => abrirModalAtualizarSenha(user)}>
                        <i className="mdi mdi-lock text-muted fs-16 align-middle me-1"></i>
                        <span className="align-middle">Atualizar Senha</span>
                    </DropdownItem>
                    <DropdownItem href="/logout"><i
                        className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span
                            className="align-middle" data-key="t-logout">Sair</span></DropdownItem>
                </DropdownMenu>
            </Dropdown>

            <ModalAlterarSenha
                isOpen={modalAtualizarSenha}
                onClose={fecharModalAtualizarSenha}
                onSave={async (id, senha) => {
                try {
                    setLoading(true);
                    const response = await fetchComAuthJson(`${api.API_URL}/alterarSenha`, {
                        method: 'POST',
                        body: JSON.stringify({ id, novaSenha: senha })
                    });

                    if (!response.ok) throw new Error(await response.text());

                    toast.success("Senha atualizada com sucesso.");
                    setModalAtualizarSenha(false);

                    const refresh = await fetchComAuth(`${api.API_URL}/usuarios`, { method: 'GET'});
                    const dataRefresh = await refresh.json();
                    // setUsuariosData(dataRefresh.data);
                    } catch (error) {
                    toast.error("Erro ao atualizar senha.");
                    console.error("Erro ao atualizar senha:", error);
                    } finally {
                    setLoading(false);
                    }
            }}
            usuario={usuarioSelecionado}
            loading={loading}
            />
        </React.Fragment>
    );
};

export default ProfileDropdown;